import { RefObject, useEffect, useRef } from 'react';

export const useAutoFocus = (ref: RefObject<HTMLElement>) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (!didMount.current && ref.current) {
      ref.current.focus();
      didMount.current = true;
    }
  }, []);
};
